/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'bi/smarts-js/smarts.min'
], (Smarts) => {

	const SUPPORTED_CHART_TYPES = {};

	return class SmartsSupportedChartTypes {
		static get(glassOptions, chartTypes) {
			const key = JSON.stringify(chartTypes);
			if ( !SUPPORTED_CHART_TYPES[key] ) {
				const smartsService = new Smarts.SmartsService(glassOptions);
				SUPPORTED_CHART_TYPES[key] = smartsService.getSupportedChartTypes(chartTypes);
			}
			return SUPPORTED_CHART_TYPES[key];
		}
	};
});
